import { Typography } from '@mui/material'
import i18n from 'lib/i18'
import { contentLanguages } from 'lib/languages'
import theme from 'lib/theme'
import { LabelsWrapper } from 'views/Orders/Orders.styled'

export const OrderLabels = ({
  labels,
}: {
  labels: { [key: string]: string }[]
}) => {
  return (
    <>
      {labels.map((label, i) => {
        let labelText = ''
        if (typeof label === 'string') {
          labelText = label
        } else if (typeof label === 'object' && label !== null) {
          labelText = label[contentLanguages[0]] || label[i18n.language]
        }
        return (
          <LabelsWrapper
            ml={1}
            backgroundColor={theme.palette.icon.hover}
            // eslint-disable-next-line react/no-array-index-key
            key={labelText + i}>
            <Typography
              color={theme.palette.commonColors.white}
              variant='body2'>
              {labelText}
            </Typography>
          </LabelsWrapper>
        )
      })}
    </>
  )
}
